import {useCallback} from 'react'
import {useMappedState, useDispatch} from 'redux-react-hook'
import {switchDialog as switchDialogAct} from 'actions'

export default function useDialogStatus (dialog) {
  const dispatch = useDispatch()
  const mapState = useCallback(state => state?.common?.[dialog] || false, [dialog])
  const switchDialog = useCallback(
    dialog2 => {
      dispatch(switchDialogAct(dialog2))
    },
    [dispatch]
  )
  return {
    dialogStatus: useMappedState(mapState),
    switchDialog
  }
}
